import { twMerge } from "tailwind-merge";

export function Preamble({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <p
      className={twMerge(
        "text-base leading-8 text-gray-600 sm:text-lg",
        className
      )}
    >
      {children}
    </p>
  );
}
